<!-- Order History -->
<div class="order-history-container">
  <!-- Page Header -->
  <div class="page-header">
    <div class="header-content">
      <div class="header-main">
        <div class="header-icon">
          <i class="fas fa-receipt"></i>
        </div>
        <div class="header-text">
          <h1 class="page-title">Order History</h1>
          <p class="page-description">View customer order records and transaction details</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Order History Table -->
  <div class="data-panel">
    <div class="panel-header">
      <div class="panel-title">
        <div class="title-icon">
          <i class="fas fa-list-alt"></i>
        </div>
        <div>
          <div class="title-text">Orders</div>
          <div class="title-subtitle">Complete list of orders placed by this customer</div>
        </div>
      </div>
    </div>

    <div class="panel-body">
      <div class="table-container">
        <table class="table">
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Inventory Items</th>
              <th>Order Amount</th>
              <th>Payment Method</th>
              <th>Order Date</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <span class="badge badge-light" style="font-family: monospace;">#28281</span>
              </td>
              <td>
                <div style="font-size: 13px; color: var(--text-secondary); max-width: 300px;">
                  Amala X2, Gbegiri Soup, Ogufe X2, Coca-Cola 50cl, Bottled Water
                </div>
              </td>
              <td>
                <span style="font-size: 13px; font-weight: 600; color: var(--text-primary);">&#8358;3,569.16</span>
              </td>
              <td>
                <span class="badge badge-soft-success badge-dot">Cash</span>
              </td>
              <td>
                <span style="font-size: 13px; color: var(--text-secondary);">25-09-2024</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
